import {useScopeTranslation} from '@uigstudio/uig-nextjs-helper';

import {Section, SectionName} from '~molecules/FiltersMenu/styles';
import {unionFiltersOptions, useFilters} from '~providers/FiltersProvider';
import {Checkbox} from '~atoms/Checkbox';
import {If} from '~atoms/If';

type CheckboxesParam = {
    filterName: keyof typeof unionFiltersOptions;
    sectionName?: string;
    isList?: boolean;
};

export default function Checkboxes({
    filterName,
    sectionName,
    isList = false,
}: CheckboxesParam) {
    const t = useScopeTranslation('common', 'filters');

    const {filters, setFilter} = useFilters();

    return (
        <Section>
            <If condition={sectionName}>
                <SectionName>{sectionName}</SectionName>
            </If>
            {unionFiltersOptions[filterName].map((option) => (
                <Checkbox
                    key={option}
                    label={t(`${filterName}.options.${option}`)}
                    value={filters[filterName] === option}
                    cy={`${isList ? 'list-' : 'map-'}${filterName}-${option}`}
                    onChange={(newValue) =>
                        // @ts-ignore
                        setFilter(filterName, newValue ? option : null)
                    }
                />
            ))}
        </Section>
    );
}
